import { Route } from 'react-router-dom';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { FileImporterPage } from '@/pages/file-upload/FileImporterPage';
import { FileImporterLegacyPage } from '@/pages/file-upload/FileImporterLegacyPage';
import { FileImporterFilesPage } from '@/pages/file-upload/FileImporterFilesPage';
import { StudyFilesPage } from '../pages/study-files/StudyFilesPage';
import { CsvImporterPage } from '@/pages/csv-upload/CsvImporterPage';
import { StudyDataImportPage } from '@/pages/data-import/StudyDataImportPage';
import { StudyFormsTemplatesPage } from '@/pages/data-import/StudyFormsTemplatesPage';
import { AuditTrailPage } from '../pages/audit-trail/AuditTrailPage';
import { WhitelistManagementPage } from '../pages/whitelist-management/WhitelistManagementPage';
import SettingsPage from '../pages/settings/SettingsPage';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import { StatusChipDemoPage } from '../pages/design-system/StatusChipDemoPage';
import { AvatarDemoPage } from '../pages/design-system/AvatarDemoPage';
import { ToastDemoPage } from '../pages/design-system/ToastDemoPage';

export const dashboardRoutes = (
  <Route element={<DashboardLayout />}>
    <Route path="/dashboard" element={<DashboardPage />} />
    <Route path="/file-upload" element={<FileImporterPage />} />
    <Route path="/file-upload-legacy" element={<FileImporterLegacyPage />} />
    <Route path="/file-upload/files" element={<FileImporterFilesPage />} />
    <Route path="/study-files" element={<StudyFilesPage />} />
    <Route path="/csv-upload" element={<CsvImporterPage />} />
    <Route path="/data-import" element={<StudyDataImportPage />} />
    <Route path="/data-import/:step" element={<StudyDataImportPage />} />
    <Route path="/data-import/mapping/:mappingId" element={<StudyDataImportPage />} />
    <Route path="/data-import/study_forms" element={<StudyFormsTemplatesPage />} />
    <Route path="/audit-trail" element={<AuditTrailPage />} />
    <Route path="/whitelist-management" element={<WhitelistManagementPage />} />
    <Route path="/settings" element={<SettingsPage />} />
    <Route path="/design-system/status-chip" element={<StatusChipDemoPage />} />
    <Route path="/design-system/avatar" element={<AvatarDemoPage />} />
    <Route path="/design-system/toast" element={<ToastDemoPage />} />
  </Route>
);
